import React from "react";
import userAvatar from "../../../assets/imgs/user-avatar.png";
import { LuBellRing } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

const Navbar = ({ meData }) => {
  const firstName = (meData?.firstName || " -- ").trim().split(/\s+/)[0];
  const navigate = useNavigate();

  return (
    <div className="flex flex-row items-center justify-start w-full gap-4 p-4">
      <div className="flex items-center justify-end w-12 h-12 rounded-full">
        <img src={userAvatar} alt="Logo" />
      </div>
      <div className="flex flex-col justify-center flex-1">
        <div className="text-xl font-bold">Hola, {firstName} 👋</div>
        <div className="text-xs font-normal">Bienvenido nuevamente!</div>
      </div>
      <div
        className="inline-flex items-center justify-center w-12 h-12 p-2 transition duration-200 ease-in-out bg-white border cursor-pointer border-slate-200 rounded-2xl active:scale-95 focus:outline-none"
        onClick={() => navigate("/notificaciones")}
      >
        <LuBellRing size={20} />
      </div>
    </div>
  );
};

export default Navbar;
